<template lang="pug">
.topup
  h2.topup-control
    span.topup-label {{ $t('pricing.topup') }}
    span.topup-currency €
    input.topup-input(type="number" v-model.number="topUpAmount" min="1" step="1")
</template>

<script lang="ts" setup>
const props = defineProps<{
  modelValue: number
}>()
const emit = defineEmits(['update:modelValue'])
const user = useUser()
let defaultTopUpAmount = 20
try {
  defaultTopUpAmount = (Number(user?.money || 0) < 0 ? -Number(user.money) : defaultTopUpAmount)
} catch (e) {
}
const initialFromModel = (() => {
  const n = Number(props.modelValue)
  if (Number.isFinite(n) && n >= 1) return n
  return defaultTopUpAmount < 1 ? 1 : defaultTopUpAmount
})()
const topUpAmount = ref(initialFromModel as number | string)
if (Number(props.modelValue) !== Number(topUpAmount.value)) {
  emit('update:modelValue', Number(topUpAmount.value))
}

watch(topUpAmount, (newValue) => {
  if (Number(newValue) >= 1) {
    return emit('update:modelValue', Number(newValue))
  }
  if (newValue === '') {
    console.log('waiting for input')
    return
  }
  topUpAmount.value = 1
})

watch(
  () => props.modelValue,
  (val) => {
    const n = Number(val)
    if (!Number.isFinite(n) || n < 1) return
    if (Number(topUpAmount.value) === n) return
    topUpAmount.value = n
  },
)
</script>
  
<style lang="postcss" scoped>
.topup {
  display: flex;
  justify-content: center;
  width: 100%;

  .topup-control {
    display: inline-flex;
    align-items: baseline;
    justify-content: center;
    gap: 0.35rem;
    margin: 0;
    color: var(--pricing-text, var(--primary-color));
    font-size: clamp(1.4rem, 3vw, 2rem);
    font-weight: 750;
    line-height: 1;
    text-align: center;
  }

  .topup-input {
    width: 120px;
    border: none;
    border-bottom: 1px solid var(--secondary-color);
    border-radius: 0;
    background: transparent;
    color: var(--pricing-text, var(--primary-color));
    font-size: 2rem;
    font-weight: 800;
    line-height: 1;
    text-align: center;
  }
}
</style>
